import React, { useState } from 'react';
import PropTypes from 'prop-types';

// alphabetized
import EmailContactsButton from './email_contacts_button';
import EmailContactsModal from './email_contacts_modal';
import vahoy from '../../../javascript/vahoy';

function EmailContacts(props) {
  const {
    button_text: buttonText,
    button_class: buttonClass,
    button_icon: buttonIcon,
  } = props;

  const [showPopup, setShowPopup] = useState(false);

  const closeModal = () => {
    setShowPopup(false);
  };

  const showModal = () => {
    setShowPopup(true);
    vahoy.track('RecentlyMessagedUsers#showInviteContactsModal');
  };

  return (
    <>
      <EmailContactsButton
        buttonText={buttonText}
        buttonClass={buttonClass}
        buttonIcon={buttonIcon}
        clickEvent={showModal}
      />
      <EmailContactsModal
        showPopup={showPopup}
        closeModal={closeModal}
      />
    </>
  );
}

EmailContacts.propTypes = {
  button_text: PropTypes.string.isRequired,
  button_class: PropTypes.string.isRequired,
  button_icon: PropTypes.string,
};

EmailContacts.defaultProps = {
  button_icon: undefined,
};

export default EmailContacts;
